let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("6wr18"), load("ffEVr"), load("hhss7"), load("cyGuT"), load("bUC6C")]).then(() => parcelRequire('a1ePi'));